import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

export const PROJECTNAME = "Valiasr Hospital";
export const PROJECTNAMEFA = "بیمارستان ولیعصر";
export const BASE_URL = publicRuntimeConfig.NEXT_PUBLIC_APP_BASE_URL;
export const TIME_REVALIDATE = 1 * 2;
export const MAPURL =
  "https://www.openstreetmap.org/export/embed.html?bbox=46.34041517972947%2C38.05128256647903%2C46.34489446878434%2C38.053213028460604&amp;layer=mapnik";
